import { isRunningInNativeApp, isVersionAtLeast } from '@muzly/shared';

type Feature = 'diagnosisDelete' | 'feedback';

/**
 * 서버 API 가 아직 없는 기능 — 꺼져 있으면 화면에서 들어가는 길(줄·버튼·팝업·라우트)을 가린다.
 * 코드는 그대로 두고, API 가 붙는 날 `true` 로 바꾼다.
 *
 * - `diagnosisDelete`: MY "진단 데이터 모두 삭제" 와 결과 상세의 회차 삭제 버튼.
 * - `feedback`: MY "의견 남기기" 줄 · 홈의 안내 팝업 · `/more/feedback` 화면.
 */
const API_READY: Record<Feature, boolean> = {
  diagnosisDelete: false,
  feedback: false,
};

/**
 * 그 기능이 기대는 네이티브 코드가 처음 실린 앱 버전. 웹은 배포 즉시 스토어의 옛 빌드에도
 * 실리므로, 셸이 이보다 낮으면 API 가 준비됐어도 들어가는 길을 가린다.
 *
 * - `diagnosisDelete`: 기기 녹음을 지우는 `purgeRecordings` RPC 가 1.0.1 에 들어갔다.
 */
const NATIVE_SINCE: Partial<Record<Feature, string>> = {
  diagnosisDelete: '1.0.1',
};

/**
 * 지금 셸에 `since` 버전의 네이티브 코드가 있는가. 브라우저는 네이티브에 기대지 않으니 늘 참이고,
 * 앱 안에서 버전을 읽을 수 없으면 거짓이다(모르는 빌드에는 열지 않는다). 버전은 셸이 문서 시작에
 * 심는 `__MUZLY_DEVICE_INFO__` 에서 읽는다 — 1.0.0 셸도 심는다.
 */
export const shellSupports = (
  since: string | undefined,
  isNative: boolean = isRunningInNativeApp(),
  appVersion: string | undefined = window.__MUZLY_DEVICE_INFO__?.appVersion,
): boolean => !since || !isNative || isVersionAtLeast(appVersion, since);

export const FEATURES: Record<Feature, boolean> = {
  diagnosisDelete:
    API_READY.diagnosisDelete && shellSupports(NATIVE_SINCE.diagnosisDelete),
  feedback: API_READY.feedback && shellSupports(NATIVE_SINCE.feedback),
};
